<footer class="footer">
  <div class="container">
    <div class="row row-grid align-items-center mb-5">
      <div class="col-lg-6">
        <h3 class="text-primary font-weight-light mb-2">
          Volkshandwerker!
        </h3>
        <h4 class="mb-0 font-weight-light">
          Die große Handwerker Suchmaschine für Deutschland, Österreich und die Schweiz.
        </h4>
      </div>
      <div class="col-lg-6 text-lg-center btn-wrapper">
        <button
          class="btn btn-icon-only btn-twitter rounded-circle mr-3"
          href="https://twitter.com/VOLKSHANDWERK?s=09"
          target="_blank"
        >
          <span class="btn-inner--icon">
            <i class="fa fa-twitter"> </i>
          </span>
        </button>
        <button
          class="btn-icon-only rounded-circle btn btn-facebook mr-3"
          href="https://fb.com/Volkshandwerker-1828282967446673"
          target="_blank"
        >
          <span class="btn-inner--icon">
            <i class="fab fa-facebook"> </i>
          </span>
        </button>
        <button
          class="btn btn-icon-only btn-instagram rounded-circle"
          href="https://instagram.com/volkshandwerker"
          target="_blank"
        >
          <span class="btn-inner--icon"> <i class="fa fa-instagram"> </i> </span>
        </button>
      </div>
    </div>
    <hr />

    <div class="row align-items-center justify-content-md-between">
      <div class="col-md-6">
        <div class="copyright">
          © {{ date | date: "yyyy" }}
          <a href="https://volkshandwerker.de" target="_blank">Volkshandwerker</a>
        </div>
      </div>
      <div class="col-md-6">
        <ul class="nav nav-footer justify-content-end">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/agb']">AGB</a>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/privacy']">Datenschutz</a>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/impressum']">Impressum</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>
